import { useState, useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { getTranslation } from "../../utils/translations";
import CityPartnerContract from "./CityPartnerContract";

export default function CityPartnerPage() {
  const { lang } = useContext(LanguageContext);
  const t = getTranslation(lang);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    country: "",
    experience: "",
    hospitalityContacts: "",
    whyApply: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");

    try {
      const res = await fetch("/api/city-partner/apply", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        throw new Error("Failed to submit application");
      }

      setSuccessMessage(t.city_partner.form.success);
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        city: "",
        country: "",
        experience: "",
        hospitalityContacts: "",
        whyApply: "",
      });
    } catch (error) {
      console.error(error);
      alert(t.city_partner.form.error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main style={{ padding: 20, display: "flex", justifyContent: "center" }}>
      <div
        style={{
          width: "100%",
          maxWidth: 1000,
          background: "#0D3B66",
          borderRadius: 14,
          padding: 24,
          color: "#fff",
        }}
      >
        <section style={{ marginBottom: 30 }}>

          <div
            style={{
              display: "inline-block",
              background: "#FF7043",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: 999,
              fontWeight: "bold",
              fontSize: 13,
              marginBottom: 14,
            }}
          >
            {t.city_partner.badge}
          </div>

          <h1
            style={{
              marginTop: 0,
              marginBottom: 10,
              fontSize: 42,
              lineHeight: 1.2,
              fontWeight: "bold"
            }}
          >
            <span style={{ color: "#FF7043" }}>
              {t.city_partner.hero_title_before}
            </span>{" "}
            <span style={{ color: "#22c55e" }}>
              {t.city_partner.hero_title_brand}
            </span>{" "}
            <span style={{ color: "#FF7043" }}>
              {t.city_partner.hero_title_after}
            </span>
          </h1>

          <h2
            style={{
              marginTop: 0,
              fontSize: 22,
              fontWeight: 500,
              color: "#cbd5f5",
              marginBottom: 16
            }}
          >
            {t.city_partner.hero_subtitle}
          </h2>

          <p
            style={{
              fontSize: 17,
              lineHeight: 1.7,
              color: "#e2e8f0"
            }}
          >
            {t.city_partner.hero_description}
          </p>

          <ul style={{ marginTop: 20, lineHeight: 1.9 }}>
            <li>✔ {t.city_partner.benefit_1}</li>
            <li>✔ {t.city_partner.benefit_2}</li>
            <li>✔ {t.city_partner.benefit_3}</li>
          </ul>
        </section>

        <section
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 20,
            marginBottom: 30,
          }}
        >
          <div
            style={{
              background: "#ffffff",
              color: "#0f172a",
              borderRadius: 12,
              padding: 20,
            }}
          >
            <h3>{t.city_partner.we_provide_title}</h3>
            <ul style={{ lineHeight: 1.8, paddingLeft: 20 }}>
              <li>{t.city_partner.provide_1}</li>
              <li>{t.city_partner.provide_2}</li>
              <li>{t.city_partner.provide_3}</li>
              <li>{t.city_partner.provide_4}</li>
            </ul>
          </div>

          <div
            style={{
              background: "#ffffff",
              color: "#0f172a",
              borderRadius: 12,
              padding: 20,
            }}
          >
            <h3>{t.city_partner.you_provide_title}</h3>
            <ul style={{ lineHeight: 1.8, paddingLeft: 20 }}>
              <li>{t.city_partner.you_1}</li>
              <li>{t.city_partner.you_2}</li>
              <li>{t.city_partner.you_3}</li>
              <li>{t.city_partner.you_4}</li>
            </ul>
          </div>
        </section>

        <div
          style={{
            background: "#fff7ed",
            color: "#9a3412",
            borderRadius: 12,
            padding: 16,
            marginBottom: 30,
            border: "1px solid #fdba74",
          }}
        >
          <strong>{t.city_partner.commercial_terms_label}</strong>{" "}
          {t.city_partner.commercial_terms_note}
        </div>

        <section
          style={{
            background: "#f8fafc",
            color: "#0f172a",
            borderRadius: 12,
            padding: 22,
          }}
        >
          <h2 style={{ marginTop: 0 }}>{t.city_partner.apply_section_title}</h2>
          <p style={{ color: "#475569", marginBottom: 20 }}>
            {t.city_partner.apply_section_desc}
          </p>

          <form
            onSubmit={handleSubmit}
            style={{ display: "grid", gap: 14 }}
          >
            <input
              type="text"
              name="fullName"
              placeholder={t.city_partner.form.full_name}
              value={formData.fullName}
              onChange={handleChange}
              required
              style={inputStyle}
            />

            <input
              type="email"
              name="email"
              placeholder={t.city_partner.form.email}
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
            />

            <input
              type="text"
              name="phone"
              placeholder={t.city_partner.form.phone}
              value={formData.phone}
              onChange={handleChange}
              style={inputStyle}
            />

            <input
              type="text"
              name="city"
              placeholder={t.city_partner.form.city}
              value={formData.city}
              onChange={handleChange}
              required
              style={inputStyle}
            />

            <input
              type="text"
              name="country"
              placeholder={t.city_partner.form.country}
              value={formData.country}
              onChange={handleChange}
              required
              style={inputStyle}
            />

            <textarea
              name="experience"
              placeholder={t.city_partner.form.experience}
              value={formData.experience}
              onChange={handleChange}
              rows={4}
              style={inputStyle}
            />

            <textarea
              name="hospitalityContacts"
              placeholder={t.city_partner.form.contacts}
              value={formData.hospitalityContacts}
              onChange={handleChange}
              rows={4}
              style={inputStyle}
            />

            <textarea
              name="whyApply"
              placeholder={t.city_partner.form.why_apply}
              value={formData.whyApply}
              onChange={handleChange}
              rows={5}
              required
              style={inputStyle}
            />

            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                background: isSubmitting ? "#94a3b8" : "#FF7043",
                color: "#fff",
                border: "none",
                borderRadius: 10,
                padding: "14px 18px",
                fontWeight: "bold",
                fontSize: 16,
                cursor: isSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {isSubmitting ? t.city_partner.form.submitting : t.city_partner.form.submit}
            </button>

            {successMessage && (
              <div
                style={{
                  background: "#dcfce7",
                  color: "#166534",
                  padding: 12,
                  borderRadius: 10,
                  fontWeight: "500",
                }}
              >
                {successMessage}
              </div>
            )}
          </form>
        </section>
        <div style={{ marginTop: 30 }}>
          <CityPartnerContract />
        </div>
      </div>
    </main>
  );
}

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  fontSize: 15,
  boxSizing: "border-box",
};